import * as qs from 'qs';
export const apiConfig = {
    returnRejectPromiseOnError: true,
    timeout: 30000,
    baseURL: window['env'].API_BASE_URL,
    headers: {
        'cache-control': 'no-cache, no-store',
        pragma: 'no-cache',
        'content-type': 'application/json',
        accept: 'application/json'
    },
    paramsSerializer: (params) => qs.stringify(params, { indices: false })
};
